import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ai-icon',
  templateUrl: './ai-icon.component.html',
  styleUrls: ['./ai-icon.component.scss'],
})
export class AiIconComponent {
  // Left empty, the icon is hidden from assistive tech, so an already-labelled parent is not
  // announced twice. Set it only where the icon is the sole carrier of the meaning.
  @Input() label = '';
}
